var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize" },
    [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v(
          _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberRegionCode"))
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-select",
        {
          staticStyle: { width: "100%" },
          model: {
            value: _vm.clone.extract_phone_number.regionCode,
            callback: function ($$v) {
              _vm.$set(_vm.clone.extract_phone_number, "regionCode", $$v)
            },
            expression: "clone.extract_phone_number.regionCode",
          },
        },
        [
          _c("a-select-option", { attrs: { value: "TR" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberTRkiyeTr"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "US" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("auto.stringFormatterExtractphonenumberUnitedStatesUs")
              )
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "GB" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("auto.stringFormatterExtractphonenumberUnitedKingdomGb")
              )
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "DE" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberGermanyDe"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "FR" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberFranceFr"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "RU" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberRussiaRu"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "IN" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberIndiaIn"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "CN" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberChinaCn"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "JP" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberJapanJp"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "KR" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("auto.stringFormatterExtractphonenumberSouthKoreaKr")
              )
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "BR" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberBrazilBr"))
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "AU" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("auto.stringFormatterExtractphonenumberAustraliaAu")
              )
            ),
          ]),
          _vm._v(" "),
          _c("a-select-option", { attrs: { value: "CA" } }, [
            _vm._v(
              _vm._s(_vm.$t("auto.stringFormatterExtractphonenumberCanadaCa"))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("small", { staticClass: "description" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$t(
                "auto.stringFormatterExtractphonenumberSelectTheRegionCodeToImprovePhoneNumberDetection"
              )
            ) +
            "\n    "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }